// @ts-nocheck
import cn from 'classnames';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getStaticMode } from '@/store/selectors/reporting.selectors';
import { Campaigns } from '@/ts-modules/reporting/Header/Campaigns';
import { SubHeaderStyle } from './SubHeader.styled';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';
import type { CampaignItem } from '@/ts-modules/reporting/CampaignListSelector/CampaignListSelector';

type Props = {
  campaigns: CampaignItem[];
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

type State = {
  backupDataDisclaimerClosed?: boolean;
};

export function SubHeader({ campaigns, user, userRoles }: Props) {
  const { formatMessage } = useIntl();
  const useBackups: boolean = useSelector(getStaticMode);

  const [{ backupDataDisclaimerClosed }, setState] = useState<State>({
    backupDataDisclaimerClosed: false
  });

  const handleCloseMsg = () => {
    setState(prevState => ({
      ...prevState,
      backupDataDisclaimerClosed: true
    }));
  };

  const backupsDisclaimerIsShown = useBackups && !backupDataDisclaimerClosed;

  const backupsDataClass = cn('reportingSubHeader__backupDataDisclaimer', {
    hidden: !backupsDisclaimerIsShown
  });

  return (
    <SubHeaderStyle className="reportingSubHeader">
      <Campaigns
        backupsDataDisclaimerEnabled={backupsDisclaimerIsShown}
        campaigns={campaigns}
        user={user}
        userRoles={userRoles}
      />
      {useBackups && (
        <section className={backupsDataClass}>
          <span className="reportingSubHeader__backupDataDisclaimerMsg">
            {formatMessage({
              defaultMessage: 'This report is based on historical data and reporting filters are limited',
              id: 'reporting.backupDataDisclaimer'
            })}
          </span>
          <span className="reportingHeader__backupDataDisclaimerCloseBtn fa fa-times" onClick={handleCloseMsg} />
        </section>
      )}
    </SubHeaderStyle>
  );
}
